import { ApplicationState } from '@app/store'
import {
  IGlobalConfigurationState,
  selectConfiguration,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import RentDetailsEditor from '../components/RentDetailsEditor'

export default connect(
  createStructuredSelector<ApplicationState, IGlobalConfigurationState>({
    configuration: selectConfiguration(),
  }),
)(RentDetailsEditor)
